namespace TabAurous.Production {
    export interface JobWorkSettlementDetailsRow {
        TransDetailId?: number;
        TransId?: number;
        ProductTypeId?: number;
        KnockOff?: number;
        Rate?: number;
        Amount?: number;
        ProductId?: number;
        ProductTypeCode?: string;
        PureWeight?: number;
        Type?: string;
    }

    export namespace JobWorkSettlementDetailsRow {
        export const idProperty = 'TransDetailId';
        export const localTextPrefix = 'Production.JobWorkSettlementDetails';
        export const deletePermission = 'Production:JobWorkSettlement:Delete';
        export const insertPermission = 'Production:JobWorkSettlement:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:JobWorkSettlement:Edit';

        export declare const enum Fields {
            TransDetailId = "TransDetailId",
            TransId = "TransId",
            ProductTypeId = "ProductTypeId",
            KnockOff = "KnockOff",
            Rate = "Rate",
            Amount = "Amount",
            ProductId = "ProductId",
            ProductTypeCode = "ProductTypeCode",
            PureWeight = "PureWeight",
            Type = "Type"
        }
    }
}
